module.exports = __webpack_public_path__ + "fa-brands-400.513aa607d398efaccc55.ttf";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf
// module chunks = 2